/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import clsx from 'clsx';
import { getUserByToken, register } from '../core/_requests';
import { Link, useNavigate } from 'react-router-dom';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { PasswordMeterComponent } from '../../../../_metronic/assets/ts/components';
import { useAuth } from '../core/Auth';
import { defaultToast } from '../../../../utils';

const initialValues = {
	firstname: '',
	lastname: '',
	email: '',
	password: '',
	changepassword: '',
	acceptTerms: false,
};

const registrationSchema = Yup.object().shape({
	email: Yup.string()
		.email('Wrong email format')
		.required('Email is required'),
	lastname: Yup.string()
		.min(
			5,
			'At least 8 or more characters consisting of the alphabet, numbers and symbols.'
		)
		.max(50, 'Maximum 50 characters')
		.required('Last name is required'),
	password: Yup.string()
		.min(
			8,
			'At least 8 or more characters consisting of the alphabet, numbers and symbols.'
		)
		.max(50, 'Maximum 50 characters')

		.required('Password is required'),
	changepassword: Yup.string()
		.min(3, 'Minimum 3 symbols')
		.max(50, 'Maximum 50 symbols')
		.required('Password confirmation is required')
		.oneOf(
			[Yup.ref('password')],
			"Password and Confirm Password didn't match"
		),
});

export function Registration() {
	const nav = useNavigate();
	const [loading, setLoading] = useState(false);
	const { saveAuth, setCurrentUser } = useAuth();
	const formik = useFormik({
		initialValues,
		validationSchema: registrationSchema,
		onSubmit: async (values, { setStatus, setSubmitting }) => {
			setLoading(true);
			try {
				const data = await register(
					values.email,
					values.lastname,
					values.password,
					values.changepassword
				);
				if (data?.data.success === true) {
					setLoading(false);
					defaultToast('Register Successfuly!');
					window.location.href = "/";
				} else {
					setLoading(false);
					defaultToast(`${data?.data.message}`, 'error');
				}
			} catch (error) {
				saveAuth(undefined);
				setStatus('The registration details is incorrect');
				setSubmitting(false);
				setLoading(false);
			}
		},
	});

	useEffect(() => {
		PasswordMeterComponent.bootstrap();
	}, []);

	return (
		<form
			className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
			noValidate
			id="kt_login_signup_form"
			onSubmit={formik.handleSubmit}
		>
			{formik.status && (
				<div className="mb-8 alert light-red">
					<div className="alert-text font-weight-bold">
						{formik.status}
					</div>
				</div>
			)}

			{/* end::Form group */}
			<div className="fv-row mb-8">
				{/* begin::Form group Lastname */}
				<label className="form-label fw-bolder text-dark fs-6">
					Name
				</label>
				<input
					placeholder="Your name"
					type="text"
					autoComplete="off"
					{...formik.getFieldProps('lastname')}
					className={clsx(
						'form-control bg-transparent',
						{
							'is-invalid':
								formik.touched.lastname &&
								formik.errors.lastname,
						},
						{
							'is-valid':
								formik.touched.lastname &&
								!formik.errors.lastname,
						}
					)}
				/>
				{formik.touched.lastname && formik.errors.lastname && (
					<div className="fv-plugins-message-container">
						<div className="fv-help-block">
							<span role="alert">{formik.errors.lastname}</span>
						</div>
					</div>
				)}
				{/* end::Form group */}
			</div>

			{/* begin::Form group Email */}
			<div className="fv-row mb-8">
				<label className="form-label fw-bolder text-dark fs-6">
					Email address
				</label>
				<input
					placeholder="you@mail.com"
					type="email"
					autoComplete="off"
					{...formik.getFieldProps('email')}
					className={clsx(
						'form-control bg-transparent',
						{
							'is-invalid':
								formik.touched.email && formik.errors.email,
						},
						{
							'is-valid':
								formik.touched.email && !formik.errors.email,
						}
					)}
				/>
				{formik.touched.email && formik.errors.email && (
					<div className="fv-plugins-message-container">
						<div className="fv-help-block">
							<span role="alert">{formik.errors.email}</span>
						</div>
					</div>
				)}
			</div>
			{/* end::Form group */}

			{/* begin::Form group Password */}
			<div className="fv-row mb-8" data-kt-password-meter="true">
				<div className="mb-1">
					<label className="form-label fw-bolder text-dark fs-6">
						Password
					</label>
					<div className="position-relative mb-3">
						<input
							type="password"
							placeholder="Your secure password"
							autoComplete="off"
							{...formik.getFieldProps('password')}
							className={clsx(
								'form-control bg-transparent',
								{
									'is-invalid':
										formik.touched.password &&
										formik.errors.password,
								},
								{
									'is-valid':
										formik.touched.password &&
										!formik.errors.password,
								}
							)}
						/>
						{formik.touched.password && formik.errors.password && (
							<div className="fv-plugins-message-container">
								<div className="fv-help-block">
									<span role="alert">
										{formik.errors.password}
									</span>
								</div>
							</div>
						)}
					</div>
					{/* begin::Meter */}
					<div
						className="d-flex align-items-center mb-3"
						data-kt-password-meter-control="highlight"
					>
						<div className="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"></div>
						<div className="flex-grow-1 bg-secondary bg-active-success rounded h-5px"></div>
					</div>
					{/* end::Meter */}
				</div>
				<div className="text-muted">
					Use 8 or more characters consisting of the alphabet, numbers
					and symbols.
				</div>
			</div>
			{/* end::Form group */}

			{/* begin::Form group Confirm password */}
			<div className="fv-row mb-5">
				<label className="form-label fw-bolder text-dark fs-6">
					Confirm Password
				</label>
				<input
					type="password"
					placeholder="Your password confirmation"
					autoComplete="off"
					{...formik.getFieldProps('changepassword')}
					className={clsx(
						'form-control bg-transparent',
						{
							'is-invalid':
								formik.touched.changepassword &&
								formik.errors.changepassword,
						},
						{
							'is-valid':
								formik.touched.changepassword &&
								!formik.errors.changepassword,
						}
					)}
				/>
				{formik.touched.changepassword && formik.errors.changepassword && (
					<div className="fv-plugins-message-container">
						<div className="fv-help-block">
							<span role="alert">
								{formik.errors.changepassword}
							</span>
						</div>
					</div>
				)}
			</div>
			<div className="text-center mt-12">
				<button
					type="submit"
					id="kt_sign_up_submit"
					className="btn btn-lg btn-primary own w-100 mb-3"
					// disabled={formik.isSubmitting || !formik.isValid}
					disabled={false}
				>
					{!loading && (
						<span className="indicator-label">Sign up</span>
					)}
					<span
							className="indicator-progress"
							style={{ display: 'block' }}
						>
							Please wait...{' '}
							<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
						</span>
				</button>
				<Link to="/auth/login">
					<button
						type="button"
						id="kt_login_signup_form_cancel_button"
						className="btn btn-lg btn-light-primary text-own w-100 text-hover-white"
					>
						Back to Sign in
					</button>
				</Link>
			</div>
			{/* end::Form group */}
		</form>
	);
}
